export const getPageTitleFromPath = pathname => {
  const pathToTitleMap = {
    // Sales Routes
    '/add-center': 'Center',
    '/create-form': 'Create Form',
    '/create-customer': 'Create Customer',
    '/create-sales-rep': 'Sales Representative',
    '/create-enquiry': 'Create Enquiry',
    '/create-organisation': 'Organisation',
    '/site-visits': 'Site Visits',
    '/create-amendments': 'Create Amendments',
    '/amendment-reports': 'Amendment Reports',
    '/create-agency': 'Agents',
    '/create-agency-rep': 'Agency Representative',
    '/customer-reports': 'Customer Reports',
    '/create-customer-group': 'Customer Group Company',
    '/enquiry-reports': 'Enquiry Reports',

    // Legal Routes
    '/create-contract': 'Create Contract',
    '/contract-reports': 'Contract Reports',

    // Operations Routes
    '/book-meeting-room': 'Book Meeting Room',
    '/meeting-room': 'Create Meeting Room',
    '/create-parking': 'Parking',
    '/create-day-pass': 'DayPasses',
    '/record-ot': 'Record OT',
    '/chargeable-customization': 'Chargeable Customization',
    '/record-stationaries': 'Record Stationaries',
    '/create-ims': 'IMS',
    '/create-exit-checklist': 'Exit Checklist',
    '/create-delivery-challan': 'Delivery Challan',
    '/checklist-response': 'Checklist Response',
    '/create-onboarding': 'Create Onboarding',
    '/onboardings-reports': 'Onboarding Reports',

    // Facilities Routes
    '/create-vendor': 'Vendor',
    '/create-equipments': 'Equipment',
    '/create-product-type': 'Product Type',
    '/maintenance-schedule': 'Maintenance Schedule',
    '/maintenance-record': 'Maintenance Record',
    '/invoice-schedular': 'Invoice Scheduler',
    '/rent-scheduler': 'Invoice Schedule',
    '/rent-scheduler-report': 'Invoice Schedule Report',

    // HR Routes
    '/create-employee': ' Create Employee',
    '/employee-details': 'Employee Details',
    '/employee-exit-checklist': 'Employee Exit Checklist',
    '/employee-exit-checklists-reports': 'Employee Exit Reports',
    '/profile': 'Profile',
    '/leave-management-v2': 'Leave Management',

    // Dashboard Routes
    '/marketing-dashboard': '',
    '/sales-dashboard': '',
    '/operations-dashboard': '',
    '/facility-dashboard': '',
    '/hr-dashboard': '',

    // Auth Routes
    '/update-user': 'Update User',
    '/register-user': 'Register User',
    '/project-costing': 'Create Project Costing',

    // Workflow Routes
    '/workflows/edit': 'Opex Workflows',
  }

  // Exact match first (works for both plain paths and paths with query strings
  // stripped below, so '/workflows/edit' matches even with ?center_id=... etc.)
  const pathWithoutQuery = pathname.split('?')[0]

  if (pathToTitleMap[pathWithoutQuery] !== undefined) {
    return pathToTitleMap[pathWithoutQuery]
  }

  if (pathWithoutQuery.startsWith('/purchase-contract-schedule/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Purchase Contract Schedule - ${id}`
  }

  if (pathWithoutQuery.startsWith('/project-costing/')) {
    return `Create Project costing`
  }

  if (pathWithoutQuery.startsWith('/project-costing-edit/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Project Costing - ${id}`
  }

  // Contract Edit: /edit-contract/CNT0000125
  if (pathWithoutQuery.startsWith('/edit-contract/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Contract - ${id}`
  }
  if (pathWithoutQuery.startsWith('/edit-onboarding/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Onboarding - ${id}`
  }
  if (pathWithoutQuery.startsWith('/edit-additional-service/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Additional Service - ${id}`
  }
  // Amendments: /amendments/:contractId, /amendments/:contractId/new, /amendments/:contractId/:amendmentId
  if (pathWithoutQuery.startsWith('/amendments/')) {
    const segments = pathWithoutQuery.split('/').filter(Boolean) // ['amendments', contractId, maybeThird]

    if (segments.length === 2) {
      // /amendments/CNT0000118
      return 'Contract Amendments'
    }

    if (segments.length === 3) {
      const contractId = segments[1]
      const third = segments[2]

      if (third === 'new') {
        // /amendments/CNT0000118/new
        return `New Amendment - ${contractId}`
      }

      // /amendments/CNT0000118/AMD0000049
      return `Amendment - ${third}`
    }
  }

  // Visitor Management Edit: /visitor-management/VMS0000028
  if (pathWithoutQuery.startsWith('/visitor-management/')) {
    const id = pathWithoutQuery.split('/').pop()
    return `Visitor Management - ${id}`
  }

  if (pathWithoutQuery.endsWith('-dashboard')) {
    return ''
  }

  const fallbackTitle = pathWithoutQuery
    .split('/')
    .pop()
    .replace(/-/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase())

  return fallbackTitle
}
